export default __webpack_public_path__ + "static/media/SMR.d17f0d77.svg";